import * as React from 'react';
import { useEffect } from 'react';
import { postMessageToParent } from '../../utils/postMessage';
import { PAYMENT_STATUS, POST_MESSAGE_TYPE, STATUS_TIME_LENGTH } from '../../common/constants';
import { useSelector } from "react-redux";
import SamsungPayBox from '../../components/common/SamsungPayBox';
import SamsungPayHeader from '../../components/common/SamsungPayHeader';
import ReturnToStoreButton from '../../components/buttons/ReturnToStoreButton';
import cancelLogo from '../../assets/pay_online_payment_cancel_2.png';
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from '../../css/pc/PcGeneral.module.css';
import classNames from 'classnames/bind';
import { persistor } from '../../utils/store';

const cx = classNames.bind(styles);

export default function TimeoutPage() {
  const { sourceOrigin } = useSelector((state) => state.paymentClient);
  const { t } = useTranslation();
  const location = useLocation();
  const timeOutReason = location.state?.timedOutType;

  useEffect(() => {
    setTimeout(() => {
      postMessageToParent({
        type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
        content: {
          status: PAYMENT_STATUS.FAIL,
          message: timeOutReason
        },
        sourceOrigin: sourceOrigin
      });

      persistor.purge();
    }, STATUS_TIME_LENGTH.TIMEOUT);
  }, []);

  return(
    <SamsungPayBox>
      <SamsungPayHeader headerMessage={"pay.gsmpi.done.msg1"}/>
      <div className="mpi-dynamic-space-div"></div>
      <div className="mpi-content">
        <div>
          <div style={{textAlign: 'center'}}><img src={cancelLogo} alt="" className={cx('mpi-unable-img')}/></div>
          <div style={{textAlign: 'center'}} className={cx('mpi-body-msg-div1')}>{t("pay.gsmpi.timeout.msg")}</div>
        </div>
      </div>
      <div className="mpi-boxbottom">
        <ReturnToStoreButton reasonMessage={timeOutReason}/>
      </div>
    </SamsungPayBox>
  );
}
